import { Action, ActionType } from "app/pages/EarlyBirdOfferList/actionTypes";
import { EarlyBirdOfferListState } from "app/pages/EarlyBirdOfferList/modules/EarlyBirdOfferList/state";

const startingState: EarlyBirdOfferListState = {
    offers: [],
    divisionId: 0,
};

export function reducer(
    state: EarlyBirdOfferListState | undefined,
    action: Action
): EarlyBirdOfferListState {
    if (!state) {
        return startingState;
    }

    switch (action.type) {
        case ActionType.PageLoaded:
            return {
                offers: action.offers,
                divisionId: action.divisionId,
            };
        default:
            return state;
    }
}